import DeviceGroupForm from "./DeviceGroupForm";
import DeviceGroupsMap from "./DeviceGroupsMap";
import { Box } from "@mui/material";
import React from "react";
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DeviceGroupShowForm from "./DeviceGroupShowForm";
import { Grid } from "@mui/material";
const GroupDeviceShow = () => {
  const district = useSelector((state) => state?.deviceDistrictSlice?.district);
  const appBarIsOpen = useSelector(
    (state) => state?.utilsSlice?.headerAppBarOpen
  );
  return (
    <Grid
      container
      sx={{
        height: "75vh",
        width: appBarIsOpen ? "78vw" : "92vw",
      }}
    >
      <Grid item xs={3} sx={{ mt: 5 }}>
        <DeviceGroupShowForm />
      </Grid>

      <Grid item xs={9}>
        <Box sx={{ height: "93%", width: "100%", ml: 11 }}>
          <DeviceGroupsMap />
        </Box>
      </Grid>
    </Grid>
  );
};

export default React.memo(GroupDeviceShow);
